module.exports = __webpack_public_path__ + "img/hugeicons_assignments.51b58f61.svg";